import React, { useState, useRef, useEffect } from 'react';
import { TextField, Button, Box, Card, CardContent, Grid, Typography, DialogTitle, Stack } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';
import DialogActions from '@mui/material/DialogActions';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import { IconButton } from '@mui/material';
import TitleIcon from '@mui/icons-material/Title';
import DrawIcon from '@mui/icons-material/Draw';
import CustomDatePicker from '../commoncomponents/CustomDatePicker';
import CustomTextField from '../commoncomponents/CustomTextField';
import dayjs from 'dayjs';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import axios from 'axios';
import { BemsGraph, FemsGraph, MasterGraph } from '../../utility/apiURLS';
import { getAuthToken ,getcompanyId} from '../../utility/tokenUtility';
import { useDispatch, useSelector } from 'react-redux';
import { Cancel } from '@mui/icons-material';
import TCActionsTypes from "../../redux/actions/TestingCommission/TCActionTypes";
import { tcCreateUpdateRepository } from '../../api/repositories/TestingandCommissioning/tcCreateUpdateRepository';


const SignatureCard = ({ onCancel, onClear, onSave, rowData, }) => {
  const companyId = getcompanyId('companyId')
  const currentDate = dayjs().format('DD/MM/YYYY');
  const [isVendorLogin, setIsVendorLogin] = useState(localStorage.getItem("roleName") === "Vendors"?true:false);
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    date: currentDate,
    contact: '',
    signature: '',
    fileSignature: null,
    mode: 'draw',
    designation: '',
    designationField: ''
  });

  const designationOptions = [
    { id: '1', label: 'Vendor' },
    { id: '2', label: 'End-User' },
    { id: '3', label: 'Nominated Person' },
    { id: '4', label: 'FMS H.O.D' },
    { id: '5', label: 'Others' },
    { id: '6', label: 'Engineer' },
    { id: '7', label: 'FEMS Staff' },
    { id: '8', label: 'Technician' },
  ];

  const [error, setError] = useState({
    name: false,
    date: false,
    contact: false,
    designationField: false,
    signupload: false
  });

  const [errorMessage, setErrorMessage] = useState({
    name: '',
    date: '',
    contact: '',
    designationField: '',
    signupload: ''
  });

  const basicDetails = useSelector(state => state.TestingCommissionDetails.basicDetails);
  const tcDetails = useSelector(state => state.TestingCommissionDetails.tcDetails);

  useEffect(() => {
    if (tcDetails?.isVendorLogin) {
      setIsVendorLogin(true);
      setFormData((prevState) => ({
        ...prevState,
        designation: "Vendor",
        designationField: { id: '1', label: 'Vendor' }
      }))
    }
  }, [])

  const signaturePadRef = useRef({});
  const updateErrorState = (hasError, errorMessage = '', name) => {
    setError(prevState => ({
      ...prevState,
      [name]: hasError
    }));
    setErrorMessage(prevState => ({
      ...prevState,
      [name]: errorMessage
    }));
  };

  const handleDateChange = (newDate) => {
    // Update the date in the form data state
    setFormData(prevState => ({
      ...prevState,
      date: newDate
    }));
  };

  const handleChange = (value, name) => {
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    if (name === 'designationField') {
      setFormData(prevState => ({
        ...prevState,
        designation: value?.label
      }));
    }

    if (name === 'contact') {
      if (value && /^\+?\d{1,15}[-\s]?\d{0,15}$/.test(value)) {
        updateErrorState(false, '', name);
      }
      else {
        updateErrorState(true, 'Please enter a valid phone number', name);
      }
    } else {
      if (value !== '' && value !== null && value !== undefined) {
        updateErrorState(false, '', name);
      }
    }
    if (name === 'name') {
      if (!value.trim()) {
        updateErrorState(true, 'Name is required', name);
      }
    }
  };


  const validateForm = () => {
    let formIsValid = true;
    const errorStatus = { ...error };
    const newErrorMessages = { ...errorMessage };

    if (!formData?.name?.trim()) {
      formIsValid = false;
      errorStatus.name = true;
      newErrorMessages.name = 'Name is required';
    }

    if (!formData?.date) {
      formIsValid = false;
      errorStatus.date = true;
      newErrorMessages.date = 'Date is required';
    }

    // if (!formData?.contact?.trim()) {
    //   formIsValid = false;
    //   errorStatus.contact = true;
    //   newErrorMessages.contact = 'Contact is required';
    // } else if (!/^\+?\d{1,15}[-\s]?\d{0,15}$/.test(formData?.contact)) {
    //   formIsValid = false;
    //   errorStatus.contact = true;
    //   newErrorMessages.contact = 'Please enter a valid phone number';
    // }

    if (!formData?.designationField) {
      formIsValid = false;
      errorStatus.designationField = true;
      newErrorMessages.designationField = 'Designation is required';
    }

    if (formData?.mode === 'upload' && !formData?.fileSignature) {
      formIsValid = false;
      errorStatus.signupload = true;
      newErrorMessages.signupload = 'Please upload a signature';
    } else if (formData?.mode === 'draw' && !formData?.signature) {
      formIsValid = false;
      errorStatus.signupload = true;
      newErrorMessages.signupload = 'Please draw a signature';
    } else if (formData?.mode === 'text' && !formData?.signature) {
      formIsValid = false;
      errorStatus.signupload = true;
      newErrorMessages.signupload = 'Please enter a signature';
    }

    setError(errorStatus);
    setErrorMessage(newErrorMessages);
    return formIsValid;
  };


  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([arrayBuffer], { type: mimeString });
  };

  const handleCancel = () => {
    setFormData({
      name: '',
      date: '',
      contact: '',
      signature: '',
      fileSignature: null,
      mode: 'draw'
    });
    onCancel();
  };

  const allowedFileExtensions = ['pdf', 'jpg', 'jpeg', 'doc'];
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileType = file?.name?.split('.').pop().toLowerCase();
      if (allowedFileExtensions.includes(fileType)) {
        setError(prevState => ({
          ...prevState,
          signupload: true
        }));
        setErrorMessage(prevState => ({
          ...prevState,
          signupload: 'Please upload a valid file'
        }));
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        setFormData(prevState => ({
          ...prevState,
          fileSignature: event.target.result,
          fileType: fileType,
          fileSize: (file.size / 1024).toFixed(2) + ' KB'
        }));
      };
      reader.readAsDataURL(file);
      setError(prevState => ({
        ...prevState,
        signupload: false
      }));
      setErrorMessage(prevState => ({
        ...prevState,
        signupload: ''
      }));
    }
  };

  const handleModeChange = (newMode) => {
    setFormData(prevState => ({
      ...prevState,
      signature: '',
      fileSignature: '',
      fileType: '',
      fileSize: '',
      mode: newMode
    }));
    if (newMode === 'draw' && error?.signupload) {
      setErrorMessage(prevState => ({
        ...prevState,
        signupload: 'Please draw a signature'
      }))
    }
    if (newMode === 'upload' && error?.signupload) {
      setErrorMessage(prevState => ({
        ...prevState,
        signupload: 'Please upload a signature'
      }))
    }
    if (newMode === 'text' && error?.signupload) {
      setErrorMessage(prevState => ({
        ...prevState,
        signupload: 'Please enter a signature'
      }))
    }
  };



  const handleClear = () => {
    // Reset the signature field in the formData state
    setFormData(prevState => ({
      ...prevState,
      signature: '', // Clear the signature
      fileType: '', // Clear the file type
      fileSize: '', // Clear the file size
    }));

    // Clear the signature canvas if in draw mode
    if (formData.mode === 'draw') {
      signaturePadRef.current.clear();
    }

    // Clear the fileSignature if in upload mode
    if (formData.mode === 'upload') {
      setFormData(prevState => ({
        ...prevState,
        fileSignature: '',
        fileType: '', // Clear the file type
        fileSize: '', // Clear the file size
      }));
    }
  };

  function uuidv4(extension) {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    }) + '.' + extension;
  }

  const registerFiles = async (selectedFiles) => {
    const token = getAuthToken('id_token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    let storeFileNameArray = [];
    let storeregsitredFilesResponse = [];
    let storefileUploadResponse = [];
    for (let i = 0; i < selectedFiles?.length; i++) {
      const formData = new FormData();
      const extension = selectedFiles[i]?.fileType;
      const fileName = uuidv4(extension); // generate a unique id
      formData.append('fileObj', selectedFiles[i]?.file, fileName); // append file with unique id as filename
      storeFileNameArray.push({ id: fileName, filename: `${selectedFiles[i]?.name}`, selectedFileId: selectedFiles[i]?.id });
      try {
        const fileUploadResponse = await axios.post(`${MasterGraph}/api/fileupload`, formData, config);
        storeregsitredFilesResponse.push(fileUploadResponse.data);
        storefileUploadResponse.push(fileUploadResponse.data);
      } catch (error) {
        console.log('Error uploading file:', error.response ? error.response.data : error.message);
      }
    }
    return { storefileUploadResponse, storeFileNameArray };
  };

  const changeDateFormat = (date) => {
    if (!date || !dayjs(date, 'DD/MM/YYYY').isValid() || date === 'Invalid Date' || date === null) {
      return '';
    }
    const convertedDate = dayjs(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const finalDate = `${convertedDate}T00:00:00`;
    return finalDate;
  };

  const saveFilesToSignature = async (payload, id) => {
    const serviceType = basicDetails?.service?.label
    const url = serviceType === "FEMS" ? FemsGraph : BemsGraph;
    const femorbem = serviceType === "FEMS" ? "femtestingcommissionsignatures" : "bemtestingcommissionsignatures";
    const femorbemText = serviceType === "FEMS" ? "femtestingandcommissionId" : "bemtestingandcommissionId";
    const config = {
      headers: {
        Authorization: `Bearer ${getAuthToken('id_token')}`
      }
    };
    const documentType = formData?.mode === "draw" || formData?.mode === "text" ? "png" : formData?.fileType;
    const commonPayload = {
      id: "",
      username: formData?.name,
      designation: formData?.designationField?.label,
      contactno: formData?.contact,
      signaturedate: changeDateFormat(formData?.date),
      filename: payload?.fileName,
      filesize: payload?.fileSize,
      documenttype: documentType,
    };
    const mergedPayload = { ...commonPayload, [femorbemText]: id };
    try {
      const response = await axios.post(`${url}/api/${femorbem}`, mergedPayload, config);
      return response.data;
    } catch (error) {
      console.log('saveFilesToAttachment Save error:', error);
    }
  };

  const dispatch = useDispatch();
  const othersDetails = useSelector(state => state?.tcReducer?.othersDetails);
  const getTrueKeys = (obj) => {
    return obj ? Object?.keys(obj)?.filter(key => obj[key])?.join(',') : '';
  };

  //why this makeStautsAsProgressFunction?
  //in edit mode whatever the status is it should be updated to In-Progress when any new signature is added
  const makeStautsAsProgressFunction = async () => {
    //after closing the dialoug update the status to In-Progress
    const othersDetailsPayload = {
      class: getTrueKeys(othersDetails?.class),
      powercord: getTrueKeys(othersDetails?.powerCard),
      isdefibrillationproof: othersDetails?.proof ? othersDetails?.proof?.value : "",
      referenceno: getTrueKeys(othersDetails?.referenceNo),
      type: getTrueKeys(othersDetails?.type),
    };
    const payload = { ...basicDetails, ...othersDetailsPayload }
    const id = basicDetails?.id;
    const serviceType = basicDetails?.service?.label;
    const status = {
      Testcommissionstatus: 'In-Progress',
      id: 2
    }
    const response = await tcCreateUpdateRepository?.updateTC(payload, id, serviceType, status);
    if (response?.id) {
      dispatch({ type: TCActionsTypes?.SET_TC_FIELD_VALUES, payload: response });
    }

  }

  const handleSave = async () => {
    const isValid = validateForm();
    if (isValid) {
      setIsSaving(true);
      if (formData?.signature || formData?.fileSignature) {
        let fileData;
        let getFileType = formData?.fileType || '';
        switch (formData.mode) {
          case 'text':
            const textBlob = new Blob([formData?.signature], { type: 'text/plain;charset=utf-8' })
            fileData = new File([textBlob], 'signature.txt');
            getFileType = 'txt'
            break;
          case 'draw':
            fileData = dataURItoBlob(formData?.signature);
            getFileType = 'png'
            break;
          case 'upload':
            // Assuming fileSignature is already a Data URL
            fileData = dataURItoBlob(formData?.fileSignature);
            break;
          default:
            fileData = null;
        };

        // Extract file details
        const fileSize = fileData ? (fileData.size / 1024).toFixed(2) + ' KB' : '';

        const data = {
          name: formData.name?.trim(),
          date: formData.date,
          contact: formData.contact,
          designation: formData.designation,
          fileType: getFileType,
          size: fileSize,
          file: fileData,// Include the file data here
          date: formData.date, // Include the date value here
        };
        const payload = [data];
        const { storeFileNameArray, storefileUploadResponse } = await registerFiles(payload);
        const tcId = basicDetails?.id;
        const saveFilesToAttachment = await saveFilesToSignature(storefileUploadResponse[0], tcId); //why storefileUploadResponse[0]? cause at a time only one file can be uploaded
        if (saveFilesToAttachment) {
          onSave(data);
          if (basicDetails?.id) {
            await makeStautsAsProgressFunction();
          }
        }
      }
    } else {
      console.log('Form validation failed');
    }
  };

  const handlePhnNo = (value) => {
    const regex = /[^\d\s\+\-]/g;
    return value.replace(regex, '');
  };

  const activeStyle = {
    backgroundColor: 'lightblue',
  };

  return (
    <Card sx={{ boxShadow: 'none', height: 'auto', overflow: 'hidden' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" component='h1'> Add Signature </Typography>
        <IconButton
          variant="contained"
          onClick={handleCancel}
        >
          <Cancel />
        </IconButton>
      </Stack>

      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            {/* <Typography variant="subtitle1" align="left">Name:</Typography> */}
            <CustomTextField
              label="Name"
              id="name"
              name="name"
              variant="outlined"
              isMandatoryField={true}
              error={error?.name}
              fullWidth
              value={formData?.name}
              onChange={handleChange}
              errorMessage={errorMessage?.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {/* <Typography variant="subtitle1" align="left">Contact:</Typography> */}
            <CustomTextField
              label="Contact"
              id="contact"
              name="contact"
              variant="outlined"
              maxlength={15}
              isMandatoryField={false}
              error={error?.contact}
              errorMessage={errorMessage?.contact}
              value={handlePhnNo(formData.contact)}
              onChange={handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <CustomDatePicker
              label="Date"
              id="date"
              name="date"
              value={formData?.date}
              isMandatoryField={true}
              maxDate={currentDate}
              error={error?.date}
              errorMessage={errorMessage?.date}
              onDateChange={handleDateChange}
              modal={true}
            />

          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomSelectInput
              modal={true}
              label="Designation"
              id="designation"
              name="designationField"
              variant="outlined"
              disabled={isVendorLogin}
              value={formData?.designationField}
              isMandatoryField={true}
              error={error?.designationField}
              errorMessage={errorMessage?.designationField}
              onChange={handleChange}
              options={designationOptions}
            />
          </Grid>
        </Grid>
      </CardContent>

      <CardContent>
        <Grid container alignItems="center" spacing={1}>
          {/* <Grid item>
            <IconButton
              variant="contained"
              onClick={() => handleModeChange('text')}
              style={{
                marginRight: 10,
                ...(formData.mode === 'text' && activeStyle),
              }}
              disabled={formData.mode === 'text' ? true : false}
            >
              <TitleIcon />
            </IconButton>
            <Typography
              variant="body1"
              align="center"
              style={formData.mode === 'text' ? { color: 'black' } : {}}
            >
              Text
            </Typography>
          </Grid> */}

          <Grid item>
            <IconButton
              variant="contained"
              onClick={() => handleModeChange('draw')}
              style={{
                marginRight: 10,
                ...(formData.mode === 'draw' && activeStyle),
              }}
              disabled={formData.mode === 'draw' ? true : false}
            >
              <DrawIcon />
            </IconButton>
            <Typography
              variant="body1"
              align="center"
              style={formData.mode === 'draw' ? { color: 'black' } : {}}
            >
              Draw
            </Typography>
          </Grid>

          {companyId === 'b4053d9f-ead7-49b5-bfee-649adae151e2' && (
  <Grid item>
    <IconButton
      variant="contained"
      onClick={() => handleModeChange('upload')}
      style={{
        marginRight: 10,
        ...(formData.mode === 'upload' && activeStyle),
      }}
      disabled={formData.mode === 'upload'}
    >
      <PhotoLibraryIcon />
    </IconButton>
    <Typography
      variant="body1"
      align="center"
      style={formData.mode === 'upload' ? { color: 'black' } : {}}
    >
      Upload
    </Typography>
  </Grid>
)}
        </Grid>

        <Box
          border={1}
          borderColor={error?.signupload ? "red" : "grey.400"}
          p={2}
          mb={2}
          position="relative"
        >
          {formData.mode === 'draw' && (
            <SignatureCanvas
              ref={signaturePadRef}
              canvasProps={{
                className: 'signatureCanvas',
                border: '1px solid black',
                style: { border: '1px solid black', width: '100%', height: '50%' },
                height: 130,
              }}
              onEnd={() => {
                const canvas = signaturePadRef.current.getCanvas();
                const ctx = canvas.getContext('2d');

                // Apply white background to the canvas
                ctx.globalCompositeOperation = 'destination-over';
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.globalCompositeOperation = 'source-over';
                // Save the signature with the white background as dataURL
                const signatureDataUrl = canvas.toDataURL();

                setFormData((prevState) => ({
                  ...prevState,
                  signature: signatureDataUrl,  // Store the signature with the white background
                }));
                setError(prevState => ({
                  ...prevState,
                  signupload: false
                }));
                updateErrorState(false, '', 'signupload');
              }}
            />
          )}

          {formData.mode === 'upload' && formData.fileSignature && (
            <img
              src={formData.fileSignature}
              alt="Uploaded Signature"
              style={{ maxWidth: '100%', marginTop: 10 }}
            />
          )}

          {formData.mode === 'text' && (
            <TextField
              fullWidth
              multiline
              rows={5}
              variant="outlined"
              value={formData.signature}
              onChange={(e) => {
                const value = e?.target?.value
                setFormData((prevState) => ({
                  ...prevState,
                  signature: value,
                }));
                if (value) {
                  updateErrorState(false, '', 'signupload');
                }
              }
              }
            />
          )}

          {formData.mode === 'upload' && (
            <>
              {formData.fileType ? (
                <></>
              ) : (
                <Button variant="outlined" component="label">
                  UPLOAD FILE
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handleFileUpload}
                  />
                </Button>
              )}
            </>
          )}
        </Box>
        {error?.signupload && (
          <Typography component={"span"} color={"error"}>
            {errorMessage?.signupload}
          </Typography>
        )}

      </CardContent>
      <DialogActions sx={{ alignItems:"end" }}>
        <Button onClick={handleCancel} color="primary" variant='outlined'>Cancel</Button>
        <Grid container justifyContent="flex-end" alignItems="end" spacing={2}>
          <Button variant="contained" onClick={handleClear} color="primary" autoFocus>{formData.mode !== 'upload' ? "Clear" : "Remove"}</Button>
          &nbsp;&nbsp;
          <Button variant="contained" onClick={handleSave} disabled={isSaving} color="primary" autoFocus>Add Signature</Button>
        </Grid>
      </DialogActions>
    </Card>
  );
};

export default SignatureCard;
